import { render } from "./OrderQuotingsShippings.vue?vue&type=template&id=2f100292"
import script from "./OrderQuotingsShippings.vue?vue&type=script&lang=js"
export * from "./OrderQuotingsShippings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__